import { createFileRoute, useRouter } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset.tsx";
import PageLayoutRoot, {
  PageLayoutContent,
  PageLayoutHeader,
} from "@/components/page-layout.tsx";
import PackageForm from "@/app/(authenticated)/$merchantId/packages/_component/package-form.tsx";
import { useMerchantProvider } from "@/app/(authenticated)/_providers/merchant-provider.tsx";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/packages/add/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { selectedMerchant } = useMerchantProvider();
  const router = useRouter();

  return (
    <ContainerInset
      breadcrumbs={[
        {
          title: "Packages",
          href: `/${selectedMerchant?.merchAccountId}/packages`,
        },
        {
          title: "New",
          href: "",
        },
      ]}
    >
      <PageLayoutRoot>
        {/* Page Header */}
        <PageLayoutHeader
          title="Create Package"
          description="Bundle multiple products together into a package with custom pricing"
        />

        {/* Main Form */}
        <PageLayoutContent>
          <PackageForm
            onCreateSuccess={async () => {
              router.history.back();
            }}
          />
        </PageLayoutContent>
      </PageLayoutRoot>
    </ContainerInset>
  );
}
